import { IconButton, IconClose16, UIText1 } from '@cian/ui-kit';
import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import * as styles from './OfferPreviewError.css';
import { EOffersFetchingMode } from '../../../../../common/actions/listingModal';
import { loadListingOffers } from '../../../../../common/actions/listingOffers';
import { TThunkDispatch } from '../../../../../common/types/redux';

interface IOfferPreviewErrorProps {
  onClose(): void;
}

export const OfferPreviewError = ({ onClose }: IOfferPreviewErrorProps) => {
  const dispatch = useDispatch<TThunkDispatch>();

  const onClick = () => {
    dispatch(loadListingOffers({ offersFetchingMode: EOffersFetchingMode.SINGLE }));
  };

  return (
    <div className={styles['root']}>
      <div className={styles['close-button']}>
        <IconButton onClick={onClose} icon={<IconClose16 />} />
      </div>
      <span className={styles['error-message']}>
        <UIText2 textAlign="center" display="block">
          Не удаётся загрузить объявление
        </UIText2>
      </span>
      <button className={styles['refresh-button']} type="button" onClick={onClick} title="Обновить">
        <UIText1 color="primary_100">Обновить</UIText1>
      </button>
    </div>
  );
};
